"use strict";

/**
 * Checks if the value is an array type.
 * @param {*} value
 * @returns {boolean}
 */
function isArray(arr) {
  return Array.isArray(arr);
}

/**
 * Gets the difference of array 1 and array 2
 * @param {Array} array1
 * @param {Array} array2
 */
function arrayDifference(array1, array2) {
  if (!array1 || !array1.length) {
    return array2 || [];
  }
  if (!array2 || !array2.length) {
    return array1;
  }
  if (array2.length > array1.length) {
    return arrayDifference(array2, array1);
  }
  return array1.filter((item1) => {
    return array2.indexOf(item1) == -1;
  });
}

module.exports = {
  isArray,
  arrayDifference
};
